import {createUseStyles} from 'react-jss';
import {Theme} from '@interface/theme';

const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;
  return {
    tournamentNotification: {
      position: 'absolute',
      zIndex: 1000,
      backgroundColor: '#182134', // Dark blue background
      color: 'white',
      padding: '10px 15px',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      cursor: 'pointer',
      pointerEvents: 'auto',
      border: '2px solid #3b68d9', // Blue border
      // Combined box shadow for both depth and glow
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3), 0 0 10px rgba(59, 104, 217, 0.5)',
      // Arrow pointing up from the top of the bubble
      '&:before': {
        content: '""',
        position: 'absolute',
        top: '-10px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '0',
        height: '0',
        borderLeft: '10px solid transparent',
        borderRight: '10px solid transparent',
        borderBottom: '10px solid #3b68d9', // Match the border color
      },
      '&:after': {
        content: '""',
        position: 'absolute',
        top: '-7px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '0',
        height: '0',
        borderLeft: '8px solid transparent',
        borderRight: '8px solid transparent',
        borderBottom: '8px solid #182134', // Match the background color
      },
      // Add a slight animation to draw attention
      animation: '$fadeIn 0.3s ease-out, $float 2s ease-in-out infinite',
    },
    // Define the fadeIn animation
    '@keyframes fadeIn': {
      '0%': {
        opacity: 0,
        transform: 'translateY(10px)',
      },
      '100%': {
        opacity: 1,
        transform: 'translateY(0)',
      },
    },
    // Define the floating animation
    '@keyframes float': {
      '0%': {
        transform: 'translateY(0)',
      },
      '50%': {
        transform: 'translateY(-5px)',
      },
      '100%': {
        transform: 'translateY(0)',
      },
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
